import { render, staticRenderFns } from "./giftPackageList.vue?vue&type=template&id=013766f5&scoped=true&"
import script from "./giftPackageList.vue?vue&type=script&lang=js&"
export * from "./giftPackageList.vue?vue&type=script&lang=js&"
import style0 from "./giftPackageList.vue?vue&type=style&index=0&id=013766f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013766f5",
  null
  
)

export default component.exports